import { defineMessages } from 'react-intl';

export default defineMessages({
    vendorsInvolved: {
        id: 'claim.views.claim-detail.claim.views.claim-detail.Vendors involved',
        defaultMessage: 'Vendors involved'
    },
    medicalPaid: {
        id: 'tdic.portal.claim-detail.claim.views.Total Medical Paid',
        defaultMessage: 'Total Medical Paid'
    },
    indemnityPaid: {
        id: 'tdic.portal.claim-detail.claim.views.Total Indemnity Paid',
        defaultMessage: 'Total Indemnity Paid'
    },
    expensesPaid: {
        id: 'tdic.portal.claim-detail.claim.views.Total Expenses Paid',
        defaultMessage: 'Total Expenses Paid'
    }
});
